import React from "react";
import Sidebar from "../../../components/Sidebar";
import TableHeader from "../../../components/TableHeader";
import PageHeader from "../../../components/PageHeader";
import Pagination from "../../../components/Pagination";
import {getSchoolYear} from "../../../utils/authority";
import vi from "date-fns/locale/vi";
import DatePicker, {registerLocale} from "react-datepicker";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import LogController from "../../../services/log";
import moment from "moment/moment";
registerLocale("vi", vi);


class LogManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: new Date(),
            toDate: new Date(),
            action: "",
            actor: "",
            serviceName: "",
            actionId: "",
            actionName: "",
            listAction: [],
            listData: [],
            pageNumber: 0,
            pageSize: 10,
            sort: 'id',
            descending: 'DESC',
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Nội dung",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Dịch vụ",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "action",
                    name: "Hành động",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "oldData",
                    name: "Dữ liệu",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "date",
                    name: "Ngày thực hiện",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "xxx",
                    name: "Thao tác",
                    style: {textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        let fromDate = new Date()
        let listAction = [
            {
                "id": "add user school",
                "name": "Thêm người dùng",
            },
            {
                "id": "add admin school",
                "name": "Thêm Admin Trường",
            },
            {
                "id": "admin detail user",
                "name": "Admin trường sửa thông tin người dùng",
            },
            {
                "id": "create user",
                "name": "Tạo người dùng",
            },
            {
                "id": "detail user",
                "name": "Sửa người dùng",
            },
            {
                "id": "state user",
                "name": "Trạng thái người dùng",
            },
            {
                "id": "login user",
                "name": "Người dùng đăng nhập",
            },
            {
                "id": "change password",
                "name": "Người dùng đổi mật khẩu",
            },
            {
                "id": "payment landing page",
                "name": "Khách hàng đăng ký ở Landing page",
            },
        ]
        this.setState({
            listAction: listAction,
            fromDate: new Date(fromDate.getFullYear(), fromDate.getMonth(), 0)
        }, ()=>{
            this.getListLog()
        })
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListLog();
            }
        );
    };
    getListLog() {
        let payload = {
            "action":  this.state.actionId,
            "actor": this.state.actor,
            "content": this.state.content,
            "serviceName": this.state.serviceName,
            "from":  moment(this.state.fromDate).format("YYYY-MM-DD HH:MM:SS"),
            "to":  moment(this.state.toDate).format("YYYY-MM-DD HH:MM:SS"),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc",
            "yearId": 0,
        }
        LogController.logUser(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "PENDING",
                "name": "Dừng hoạt động"
            },
            {
                "id": "ACTIVE",
                "name": "Đang hoạt động"
            },
            {
                "id": "DISABLE",
                "name": "Đã khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }

    render() {
        let {listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="log-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                                <div className="content-loading col-12 ml-3 align-items-center"
                                     style={{display: 'block'}}>
                                    <div className="spinner-grow text-info"/>
                                </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý log"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Từ ngày</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.fromDate === '' ? null : new Date(this.state.fromDate)}
                                                    maxDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            try {
                                                                this.setState({
                                                                    fromDate: date,
                                                                }, ()=>{
                                                                    this.getListLog()
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tới ngày</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.toDate === '' ? null : new Date(this.state.toDate)}
                                                    maxDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            try {
                                                                this.setState({
                                                                    toDate: date,
                                                                }, ()=>{
                                                                    this.getListLog()
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn hành động</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listAction}
                                                    getOptionLabel={option => option.name?option.name:"No Name"}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.actionName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên hành động'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                actionName: val.name
                                                            })
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val.id != undefined){
                                                            this.setState({
                                                                actionId: val.id,
                                                                actionName: val.name,
                                                            }, ()=>{
                                                                this.getListLog()
                                                            })
                                                        }else {
                                                            this.setState({
                                                                actionId: "",
                                                                actionName: "",
                                                            })
                                                        }
                                                        // this.getListPeopleInCharge()
                                                    }}

                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên đăng nhập</label>
                                                <input
                                                    maxLength={255}
                                                    type="text"
                                                    placeholder="Nhập tên đăng nhập"
                                                    className="form-control shadow-none"
                                                    value={this.state.content}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            content: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm mr-2"
                                                    onClick={() => this.getListLog()}
                                                >
                                                    Tìm kiếm
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                            <tr style={{height: 50}}>
                                                                <td style={{textAlign: "center"}} scope="row">
                                                                    {" "}
                                                                    {this.state.pageNumber * this.state.pageSize +
                                                                        index +
                                                                        1}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.content}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.serviceName}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.action}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {row.request}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {moment(row.createdDate).format("DD-MM-YYYY")}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LogManagement;
